<div class="nav-element free-spins" [ngClass]="{'showIt' : inited}" *ngIf="!lotteryService.isMobile && !lotteryService.isTablet">
  <div class="free-spin-button przycisk medium" (click)="freeSpinsClick()">{{ 'awesomeNav.freeSpin' | translate }}</div>
  <span class="elements fruit_1"></span>
  <span class="elements fruit_2"></span>
  <span class="elements fruit_3"></span>
  <span class="elements fruit_4"></span>
  <span class="elements el_1"></span>
  <span class="elements el_2"></span>
  <span class="elements el_3"></span>
</div>

<div class="free-spins-mobile" *ngIf="(lotteryService.isMobile || lotteryService.isTablet)" [ngClass]="{'closingIt' : closingFreeSpins}">
  <div class="free-spin-button przycisk medium" (click)="freeSpinsClick()">{{ 'awesomeNav.freeSpin' | translate }}</div>
  <span class="close-free-spin" (click)="closeFreeSpins()"></span>
</div>

